<template>
  <d2-container>
   <div class="supports">
      <div class="supportcontent">
        <div class="supportcontcard">
          <h4 class="supportcontcardTitle">提交成功</h4>
          <div class="supportcontcardMsg">
            <p>您的表单已提交成功，</p>
            <p>稍后会有工作人员第一时间与您电话联系 。</p>
            <p>如果您现在就需要帮助，可立即拨打 <span>17858952922</span> 与我们联系!</p>
          </div>
          
          </div>
      </div>

      <!-- <base-bottom></base-bottom> -->
   </div>
  </d2-container>
</template>

<script>
import baseBottom from '../components/base-bottom'
import {addNewList} from "@/api/data.js"

export default {
  name: 'hosting',
  components: {
    baseBottom
  },
  data() {
    return {
    }
  },
}
</script>

<style scoped>

.supports{
  min-height: 100vh;
}
.supportcontent{
  width: 100%;
  margin: 50px auto 100px;
}
.supportcontcard{
  width: 100%;
}
.supportcontcardMsg {
  font-size: 12px;
  color: #333;
  letter-spacing: 0px;
  text-align: left;
  font-weight: 400;
  padding: 0 0 20px 7%;
  margin: 0;
}
.supportcontcardMsg p{
  margin: 8px 0;
}
.supportcontcardMsg p span{
  color: #409EFF;
}
.supportcontcardTitle{
  text-align: left;
  font-size: 20px;
  color: #000;
  letter-spacing: 2px;
  font-weight: 400;
  margin: 0;
  padding: 20px 7% 12px;
  font-weight: bold;
}


</style>
